<template>
  <div class="container spacing-top-50">
    <div class="columns">
      <div class="column">
        <div class="columns table-padding-fix">
          <div class="column is-4">
            <b-field label="Filteren">
                <b-input v-model="search"></b-input>
            </b-field>
          </div>
          <div class="column">
            <div class="spacing-top">
              <a class="button is-primary" :class="{ 'is-loading': isSyncing }" v-on:click="sync">Debiteuren synchroniseren</a>
            </div>
          </div>
        </div>

        <section class="spacing-top">
          <b-table
            :data="filteredList"
            :paginated="true"
            :pagination-simple="false"
            :per-page="15"
            default-sort-direction="'asc'"
            default-sort="subNr">
            <template slot-scope="debiteur">
              <b-table-column field="subNr" width="100" label="Nr." sortable numeric>
                {{ debiteur.row.subNr }}
              </b-table-column>
              <b-table-column field="acctName" label="Naam" sortable>
                {{ debiteur.row.acctName }}
              </b-table-column>
              <b-table-column field="addrLine1" label="Adres" sortable>
                {{ debiteur.row.addrLine1 }}
              </b-table-column>
              <b-table-column field="city" label="Stad" sortable>
                {{ debiteur.row.city }}
              </b-table-column>
              <b-table-column field="postCode" label="Post code" sortable>
                {{ debiteur.row.postCode }}
              </b-table-column>
              <b-table-column field="country" label="Land" sortable>
                {{ debiteur.row.country }}
              </b-table-column>
              <b-table-column field="vatNr" label="BTW nummer" sortable>
                {{ debiteur.row.vatNr }}
              </b-table-column>
              <b-table-column field="vatCode" label="BTW code" sortable>
                {{ debiteur.row.vatCode }}
              </b-table-column>
            </template>
          </b-table>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'debiteuren'
    ]),
    filteredList () {
      const searchQuery = this.search.toLowerCase().split('/')

      if (searchQuery.length <= 0) {
        return this.debiteuren
      }

      return this.debiteuren.filter(crediteur => {
        for (let search of searchQuery) {
          for (var key in crediteur) {
            const value = String(crediteur[key]).toLowerCase()

            if (value.includes(search)) {
              return true
            }
          }
        }

        return false
      })
    }
  },
  data () {
    return {
      search: '',
      isSyncing: false
    }
  },
  async created () {
    try {
      await this.$store.dispatch('getDebiteuren', true)
    } catch (error) {
      this.$snackbar.open({
        type: 'is-danger',
        message: 'Er ging iets fout tijdens het ophalen van de debiteuren.'
      })
    }
  },
  methods: {
    async sync () {
      this.isSyncing = true

      await this.$store.dispatch('syncDebiteuren').catch(() => {
        this.$snackbar.open({
          type: 'is-danger',
          message: 'Er ging iets fout tijdens het synchroniseren van de debiteuren.'
        })
      })

      this.isSyncing = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/debiteuren.vue